var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.58,
    y: 48.61,
    width: 266.48,
    height: 266.48,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.06,315.09c0-1.92-.09-106.69-.22-266.48l.22.23-266.45,0h0l.26-.26c0,97.59,0,189,0,266.48l-.23-.22,266.48.22-266.48.23h-.22v-.23c0-77.44,0-168.89,0-266.48v-.26h.29l266.45,0h.23v.22C455.15,208.4,455.07,313.17,455.06,315.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,82.49h2.92V88.1A9.5,9.5,0,0,1,265,89.86c-4.34,0-7.54-3-7.54-7.15s3.2-7.15,7.6-7.15A7.37,7.37,0,0,1,270.84,78l-2,1.9a4.68,4.68,0,0,0-3.58-1.56,4.42,4.42,0,1,0,0,8.84,5.13,5.13,0,0,0,2.49-.59Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.67,85.18h-8a2.84,2.84,0,0,0,3,2.13,3.61,3.61,0,0,0,2.67-1L283,88.06a5.55,5.55,0,0,1-4.38,1.72c-3.68,0-6.07-2.31-6.07-5.47a5.41,5.41,0,0,1,5.67-5.47,5.26,5.26,0,0,1,5.53,5.51C283.73,84.59,283.69,84.92,283.67,85.18Zm-8.08-1.8h5.24a2.66,2.66,0,0,0-5.24,0Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,89.11a4.43,4.43,0,0,1-2.51.67c-2.5,0-4-1.29-4-3.81V81.6h-1.63V79.23h1.63V76.65h3.08v2.58h2.65V81.6h-2.65v4.33a1.24,1.24,0,0,0,1.33,1.4,2,2,0,0,0,1.24-.4Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,75.8a1.76,1.76,0,0,1,1.91-1.72,1.73,1.73,0,0,1,1.92,1.66,1.92,1.92,0,0,1-3.83.06ZM300,79H303V89.62H300Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,83.54v6.08h-3.08V84c0-1.71-.79-2.5-2.15-2.5s-2.54.9-2.54,2.86v5.25H305.9V79h2.94v1.24a4.64,4.64,0,0,1,3.51-1.4C314.86,78.84,316.75,80.3,316.75,83.54Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,89.11a4.42,4.42,0,0,1-2.5.67c-2.51,0-4-1.29-4-3.81V81.6h-1.64V79.23h1.64V76.65h3.08v2.58h2.64V81.6h-2.64v4.33a1.23,1.23,0,0,0,1.32,1.4,2,2,0,0,0,1.24-.4Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,84.31c0-3.2,2.47-5.47,5.85-5.47s5.82,2.27,5.82,5.47-2.44,5.47-5.82,5.47S332.58,87.51,332.58,84.31Zm8.55,0a2.72,2.72,0,1,0-2.7,2.94A2.67,2.67,0,0,0,341.13,84.31Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,79V89.62h-2.93V88.36a4.31,4.31,0,0,1-3.29,1.42c-2.67,0-4.55-1.5-4.55-4.78V79h3.08v5.55c0,1.77.79,2.56,2.16,2.56s2.45-.91,2.45-2.86V79Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,84.31c0-3.2,2.46-5.47,5.92-5.47a4.89,4.89,0,0,1,4.76,2.7l-2.39,1.29A2.64,2.64,0,0,0,365,81.37a2.94,2.94,0,0,0,0,5.88,2.6,2.6,0,0,0,2.39-1.46l2.39,1.3A4.93,4.93,0,0,1,365,89.78C361.54,89.78,359.08,87.51,359.08,84.31Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.31,83.54v6.08h-3.08V84c0-1.71-.79-2.5-2.15-2.5s-2.55.9-2.55,2.86v5.25h-3.08V75h3.08V80.1a4.68,4.68,0,0,1,3.38-1.26C380.42,78.84,382.31,80.3,382.31,83.54Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.55,100.41c0,.14-32.6.26-72.8.26s-72.79-.12-72.79-.26,32.58-.26,72.79-.26S392.55,100.27,392.55,100.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,146.33s0-.34,0-1,0-1.62,0-2.88c0-2.55,0-6.3,0-11.21l.09.1-192.86.16h0l.26-.26v15.08l-.26-.26,136.83.11,41,.08,11.12,0,2.9,0,1,0-1,0-2.86,0-11.06,0-41,.08-137,.11h-.26V131h.27l192.86.16h.1v.1c0,4.93,0,8.71-.05,11.26,0,1.26,0,2.21,0,2.87S416.07,146.33,416.07,146.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,120.62V125h-.83l-2.18-2.66V125h-1v-4.38h.83l2.18,2.66v-2.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,123.08V125h-.92v-.42a1.11,1.11,0,0,1-1,.47c-.79,0-1.26-.44-1.26-1s.42-1,1.45-1h.77c0-.42-.25-.66-.77-.66a1.63,1.63,0,0,0-1,.31l-.35-.68a2.58,2.58,0,0,1,1.45-.41C231.08,121.58,231.68,122.06,231.68,123.08Zm-1,.85v-.34H230c-.45,0-.6.17-.6.39s.21.41.55.41A.71.71,0,0,0,230.7,123.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.24,123.07V125h-1v-1.78c0-.54-.25-.79-.64-.79s-.74.28-.74.88V125h-1v-1.78c0-.54-.23-.79-.64-.79s-.74.28-.74.88V125h-1v-3.37h.93V122a1.37,1.37,0,0,1,1.06-.44,1.23,1.23,0,0,1,1.1.55,1.54,1.54,0,0,1,1.22-.55A1.3,1.3,0,0,1,238.24,123.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,123.59h-2.54a.9.9,0,0,0,1,.68,1.12,1.12,0,0,0,.84-.33l.52.56a2,2,0,0,1-3.31-1.19,1.72,1.72,0,0,1,1.8-1.73,1.66,1.66,0,0,1,1.75,1.75A2.46,2.46,0,0,1,242.43,123.59Zm-2.56-.57h1.66a.84.84,0,0,0-1.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,184s0-.34,0-1,0-1.62,0-2.88c0-2.55,0-6.3,0-11.21l.09.1-192.86.16h0l.26-.26V184l-.26-.26,136.83.11,41,.08,11.12,0,2.9,0,1,0-1,0-2.86,0-11.06,0-41,.08-137,.11h-.26v-15.6h.27l192.86.17h.1v.09c0,4.93,0,8.71-.05,11.26,0,1.26,0,2.21,0,2.87S416.07,184,416.07,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,259.61s0-.35,0-1,0-1.69,0-3c0-2.66,0-6.57,0-11.64,0-10.15-.05-25-.09-43.59l.16.17-192.86.09h0l.26-.26c0,20.52,0,40.46,0,59.27l-.25-.25,137.9.11,40.36.08,10.84,0h2.81l1,0-.93,0h-2.78l-10.78,0-40.3.07-138.08.11h-.26V200.08h.27l192.86.1h.17v.16c0,18.68-.07,33.51-.09,43.69,0,5.06,0,9,0,11.6,0,1.31,0,2.3,0,3S416.07,259.61,416.07,259.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.11,161.82v.82h-3.39v-4.38H227v.81h-2.31v1h2v.79h-2v1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.53,160.71v1.93h-1v-1.78c0-.54-.24-.79-.63-.79s-.75.28-.75.88v1.69h-1v-1.78c0-.54-.24-.79-.64-.79s-.74.28-.74.88v1.69h-1v-3.37h.94v.39a1.34,1.34,0,0,1,1.05-.44,1.26,1.26,0,0,1,1.11.55,1.53,1.53,0,0,1,1.21-.55A1.31,1.31,0,0,1,233.53,160.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.38,160.72v1.92h-.91v-.42a1.12,1.12,0,0,1-1,.47c-.79,0-1.26-.44-1.26-1s.42-1,1.45-1h.77c0-.42-.25-.66-.77-.66a1.63,1.63,0,0,0-1,.31l-.35-.68a2.6,2.6,0,0,1,1.45-.41C236.79,159.22,237.38,159.7,237.38,160.72Zm-1,.85v-.34h-.66c-.46,0-.61.17-.61.39s.21.41.56.41A.71.71,0,0,0,236.4,161.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,158.26a.56.56,0,0,1,.61-.55.56.56,0,0,1,.61.53.61.61,0,0,1-1.22,0Zm.12,1h1v3.37h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.14,158h1v4.64h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,160.72v1.92h-.91v-.42a1.12,1.12,0,0,1-1,.47c-.79,0-1.25-.44-1.25-1s.41-1,1.44-1h.78c0-.42-.25-.66-.78-.66a1.65,1.65,0,0,0-1,.31l-.35-.68a2.6,2.6,0,0,1,1.45-.41C246.18,159.22,246.77,159.7,246.77,160.72Zm-1,.85v-.34h-.67c-.46,0-.6.17-.6.39s.2.41.55.41A.73.73,0,0,0,245.8,161.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,158v4.64h-.93v-.39a1.32,1.32,0,0,1-1.06.44,1.74,1.74,0,0,1,0-3.47,1.27,1.27,0,0,1,1,.41V158Zm-1,2.95a.86.86,0,1,0-.86.94A.85.85,0,0,0,250.16,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.45,158v4.64h-.94v-.39a1.3,1.3,0,0,1-1,.44,1.74,1.74,0,0,1,0-3.47,1.27,1.27,0,0,1,1,.41V158Zm-1,2.95a.86.86,0,1,0-.86.94A.85.85,0,0,0,254.49,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,159.22v.9h-.22a.83.83,0,0,0-.89.94v1.59h-1v-3.37h.94v.45A1.32,1.32,0,0,1,258.43,159.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.26,161.23h-2.54a.9.9,0,0,0,1,.68,1.14,1.14,0,0,0,.84-.33l.52.56a2,2,0,0,1-3.31-1.19,1.72,1.72,0,0,1,1.8-1.73,1.67,1.67,0,0,1,1.75,1.75A2.46,2.46,0,0,1,262.26,161.23Zm-2.56-.57h1.66a.84.84,0,0,0-1.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.6,162.32l.33-.7a2.25,2.25,0,0,0,1.17.33c.45,0,.62-.12.62-.31,0-.55-2,0-2-1.33,0-.64.57-1.09,1.55-1.09a2.74,2.74,0,0,1,1.3.3l-.33.69a1.9,1.9,0,0,0-1-.25c-.43,0-.62.14-.62.31,0,.58,2,0,2,1.35,0,.62-.58,1.07-1.59,1.07A2.88,2.88,0,0,1,262.6,162.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,162.32l.33-.7a2.25,2.25,0,0,0,1.17.33c.45,0,.62-.12.62-.31,0-.55-2,0-2-1.33,0-.64.57-1.09,1.55-1.09a2.74,2.74,0,0,1,1.3.3l-.33.69a1.9,1.9,0,0,0-1-.25c-.43,0-.62.14-.62.31,0,.58,2,0,2,1.35,0,.62-.58,1.07-1.59,1.07A2.88,2.88,0,0,1,265.92,162.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.7,195.37v-2.63l-1.28,2.17H226l-1.28-2.11v2.57h-.95V191h.83l1.64,2.72,1.62-2.72h.83v4.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,194h-2.55a.9.9,0,0,0,1,.68,1.15,1.15,0,0,0,.85-.33l.52.57a1.78,1.78,0,0,1-1.39.54,1.75,1.75,0,0,1-1.92-1.73,1.72,1.72,0,0,1,1.79-1.74,1.68,1.68,0,0,1,1.76,1.75C232.92,193.78,232.9,193.88,232.9,194Zm-2.56-.57H232a.84.84,0,0,0-1.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,195.06l.32-.7a2.38,2.38,0,0,0,1.17.32c.46,0,.62-.12.62-.3,0-.55-2,0-2-1.34,0-.63.58-1.09,1.56-1.09a2.73,2.73,0,0,1,1.29.3l-.32.69a2,2,0,0,0-1-.25c-.44,0-.63.14-.63.32,0,.57,2,0,2,1.34,0,.63-.59,1.07-1.59,1.07A3,3,0,0,1,233.24,195.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.56,195.06l.32-.7a2.38,2.38,0,0,0,1.17.32c.46,0,.62-.12.62-.3,0-.55-2,0-2-1.34,0-.63.58-1.09,1.56-1.09a2.73,2.73,0,0,1,1.29.3l-.32.69a2,2,0,0,0-1-.25c-.44,0-.63.14-.63.32,0,.57,2,0,2,1.34,0,.63-.59,1.07-1.59,1.07A3,3,0,0,1,236.56,195.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,193.45v1.92h-.91V195a1.1,1.1,0,0,1-1,.47c-.78,0-1.25-.44-1.25-1s.42-1,1.44-1h.78c0-.42-.25-.66-.78-.66a1.65,1.65,0,0,0-1,.31l-.35-.68a2.6,2.6,0,0,1,1.45-.41C242.59,192,243.18,192.43,243.18,193.45Zm-1,.86V194h-.67c-.46,0-.6.17-.6.4s.2.4.55.4A.73.73,0,0,0,242.21,194.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.57,192v2.8c0,1.25-.67,1.82-1.89,1.82a2.77,2.77,0,0,1-1.65-.46l.39-.7a2,2,0,0,0,1.19.38c.69,0,1-.31,1-.92v-.14a1.41,1.41,0,0,1-1.07.42,1.63,1.63,0,1,1,0-3.26,1.36,1.36,0,0,1,1.12.49V192Zm-1,1.57a.89.89,0,1,0-.88.83A.82.82,0,0,0,246.61,193.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,194h-2.55a.9.9,0,0,0,1,.68,1.15,1.15,0,0,0,.85-.33l.52.57a1.79,1.79,0,0,1-1.39.54,1.74,1.74,0,0,1-1.92-1.73A1.72,1.72,0,0,1,250,192a1.68,1.68,0,0,1,1.76,1.75C251.78,193.78,251.76,193.88,251.76,194Zm-2.56-.57h1.66a.84.84,0,0,0-1.66,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.14,296H354.92a12.18,12.18,0,0,1-12.19-12.18h0a12.18,12.18,0,0,1,12.19-12.18h50.22a12.18,12.18,0,0,1,12.18,12.18h0A12.18,12.18,0,0,1,405.14,296Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,285.71l.47-1a3.47,3.47,0,0,0,1.95.61c.81,0,1.14-.27,1.14-.63,0-1.11-3.44-.35-3.44-2.55,0-1,.81-1.85,2.5-1.85a3.94,3.94,0,0,1,2.05.53l-.42,1a3.39,3.39,0,0,0-1.64-.47c-.82,0-1.13.31-1.13.68,0,1.09,3.45.34,3.45,2.52,0,1-.82,1.83-2.52,1.83A4.17,4.17,0,0,1,369,285.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,284.39h-3.44a1.2,1.2,0,0,0,1.3.91,1.52,1.52,0,0,0,1.14-.44l.71.76a2.67,2.67,0,0,1-4.49-1.61,2.32,2.32,0,0,1,2.44-2.34,2.26,2.26,0,0,1,2.37,2.36C379.25,284.13,379.23,284.28,379.22,284.39Zm-3.46-.77H378a1.14,1.14,0,0,0-2.24,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,283.68v2.61h-1.33v-2.4c0-.74-.33-1.08-.92-1.08s-1.09.39-1.09,1.23v2.25h-1.32v-4.55h1.26v.53a2,2,0,0,1,1.51-.6A1.79,1.79,0,0,1,384.79,283.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,280v6.28h-1.26v-.52a1.74,1.74,0,0,1-1.42.59,2.35,2.35,0,0,1,0-4.69,1.75,1.75,0,0,1,1.36.55V280Zm-1.29,4a1.17,1.17,0,1,0-1.16,1.27A1.16,1.16,0,0,0,389.38,284Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.83,69.59a21.35,21.35,0,0,0-2.3-.1,9.38,9.38,0,0,0-5.67,2.27,9.21,9.21,0,0,0-3.1,8.22,8.91,8.91,0,0,0,.73,2.53,9.15,9.15,0,0,0,1.49,2.3,9.13,9.13,0,0,0,10.56,2.3,8.74,8.74,0,0,0,2.31-1.47,8.57,8.57,0,0,0,1.72-2,9.19,9.19,0,0,0,.6-8.76A9.44,9.44,0,0,0,224,70.45a21.18,21.18,0,0,0-2.13-.86,7,7,0,0,1,2.22.68,9.33,9.33,0,0,1,4.45,4.45,9.47,9.47,0,0,1,.93,4.32A9.59,9.59,0,0,1,228,83.9a9.57,9.57,0,0,1-4.22,3.67,9.56,9.56,0,0,1-11.15-2.43A9,9,0,0,1,211,82.71a8.83,8.83,0,0,1-.75-2.66,9.51,9.51,0,0,1,3.33-8.57,9.42,9.42,0,0,1,5.9-2.2A7.34,7.34,0,0,1,221.83,69.59Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.56,70a82.44,82.44,0,0,1,4.52,8.09,79.6,79.6,0,0,1,4,8.33,88,88,0,0,1-4.51-8.09A81,81,0,0,1,216.56,70Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,69.47a76.19,76.19,0,0,1,4.38,7.83,79.59,79.59,0,0,1,3.93,8.07,77.29,77.29,0,0,1-4.39-7.83A78.12,78.12,0,0,1,218.47,69.47Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.68,69.5a60.2,60.2,0,0,1,3.87,6.86,58,58,0,0,1,3.42,7.1,61.48,61.48,0,0,1-3.88-6.86A60.41,60.41,0,0,1,220.68,69.5Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.06,69.85a41.15,41.15,0,0,1,3.17,5.51,38.3,38.3,0,0,1,2.7,5.75,41.15,41.15,0,0,1-3.17-5.51A38.3,38.3,0,0,1,223.06,69.85Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.84,71.11a81.44,81.44,0,0,1,4.52,8.09,81,81,0,0,1,4.06,8.33,81,81,0,0,1-4.52-8.09A83.62,83.62,0,0,1,214.84,71.11Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.13,72.22a81.49,81.49,0,0,1,4.52,8.08,83.29,83.29,0,0,1,4,8.33,81,81,0,0,1-4.52-8.09A83.81,83.81,0,0,1,213.13,72.22Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,74a60.19,60.19,0,0,1,3.93,7,61.13,61.13,0,0,1,3.47,7.21,60.91,60.91,0,0,1-3.93-7A62.36,62.36,0,0,1,211.75,74Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73,76.4a37.49,37.49,0,0,1,3.15,5.47,39.17,39.17,0,0,1,2.69,5.71,38.17,38.17,0,0,1-3.15-5.47A37.27,37.27,0,0,1,210.73,76.4Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,283.77c-.06,0-.4-.73-1.39-1.84a9.33,9.33,0,0,0-5.35-2.93,9.13,9.13,0,0,0-8.32,2.82,9.17,9.17,0,0,0-2.32,4.78,9.1,9.1,0,0,0,4.92,9.61,8.61,8.61,0,0,0,2.61.86,8.88,8.88,0,0,0,2.62.06A9.28,9.28,0,0,0,296.13,286c-.32-1.44-.74-2.17-.68-2.2a7.23,7.23,0,0,1,.88,2.16,9.32,9.32,0,0,1-.62,6.26,9.45,9.45,0,0,1-2.75,3.46,9.59,9.59,0,0,1-4.68,2,9.21,9.21,0,0,1-2.77,0,9.31,9.31,0,0,1-2.75-.89,9.58,9.58,0,0,1-5.19-10.16,9,9,0,0,1,.89-2.75,9.13,9.13,0,0,1,1.58-2.27,9.53,9.53,0,0,1,8.73-2.86,9.36,9.36,0,0,1,5.45,3.17A7.13,7.13,0,0,1,295.45,283.77Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.78,280a84.23,84.23,0,0,1-3.39,8.63,82.77,82.77,0,0,1-3.86,8.41,84,84,0,0,1,3.38-8.62A83.55,83.55,0,0,1,291.78,280Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,281.1a77.28,77.28,0,0,1-3.27,8.36,77.56,77.56,0,0,1-3.75,8.15,76,76,0,0,1,3.27-8.35A79.6,79.6,0,0,1,293.41,281.1Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,282.83a60.5,60.5,0,0,1-2.85,7.35,57.72,57.72,0,0,1-3.32,7.14,59.11,59.11,0,0,1,2.85-7.35A57.72,57.72,0,0,1,294.79,282.83Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,284.89a39,39,0,0,1-2.24,5.95,39.51,39.51,0,0,1-2.73,5.73,39.08,39.08,0,0,1,2.25-5.94A40,40,0,0,1,296,284.89Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.84,279.35a85.69,85.69,0,0,1-3.39,8.62,84.94,84.94,0,0,1-3.86,8.42,82.66,82.66,0,0,1,3.38-8.63A79,79,0,0,1,289.84,279.35Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,278.72a80.4,80.4,0,0,1-3.38,8.62,82.37,82.37,0,0,1-3.86,8.42,82.05,82.05,0,0,1,3.38-8.62A82.37,82.37,0,0,1,287.89,278.72Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.67,278.76a61.23,61.23,0,0,1-2.89,7.46,61.88,61.88,0,0,1-3.37,7.25A62.21,62.21,0,0,1,282.3,286,61.58,61.58,0,0,1,285.67,278.76Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,279.52a39.35,39.35,0,0,1-2.23,5.9,36.51,36.51,0,0,1-2.71,5.7,39.35,39.35,0,0,1,2.23-5.9A37.61,37.61,0,0,1,283.14,279.52Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,93.38a27.21,27.21,0,0,0-.63-4.17,16.5,16.5,0,0,0-1.92-4.53,17,17,0,0,0-20.4-7.21,15.76,15.76,0,0,0-4.28,2.31,18.4,18.4,0,0,0-1.92,1.63,18.58,18.58,0,0,0-1.66,2,16.84,16.84,0,0,0,0,20,18.58,18.58,0,0,0,1.66,2,18.4,18.4,0,0,0,1.92,1.63,15.76,15.76,0,0,0,4.28,2.31,17,17,0,0,0,20.4-7.21,16.5,16.5,0,0,0,1.92-4.53,27.21,27.21,0,0,0,.63-4.17,1.16,1.16,0,0,1,0,.28c0,.21,0,.48,0,.82a7.71,7.71,0,0,1-.11,1.33,11.89,11.89,0,0,1-.33,1.79,16.37,16.37,0,0,1-1.86,4.63,17.36,17.36,0,0,1-11.67,8.24,17.42,17.42,0,0,1-9.14-.73,16.43,16.43,0,0,1-4.42-2.36,19.55,19.55,0,0,1-2-1.68,18.6,18.6,0,0,1-1.71-2,17.32,17.32,0,0,1,0-20.61,20.81,20.81,0,0,1,1.71-2,19.55,19.55,0,0,1,2-1.68A16.43,16.43,0,0,1,411,77a17.25,17.25,0,0,1,16.44,2.56,17.13,17.13,0,0,1,4.37,5,16.37,16.37,0,0,1,1.86,4.63A11.89,11.89,0,0,1,434,91a7.71,7.71,0,0,1,.11,1.33c0,.34,0,.61,0,.82A1.16,1.16,0,0,1,434.08,93.38Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.27,84.14c.09.11-5.65,5.06-12.83,11S405.37,106,405.28,105.84s5.65-5,12.83-11S431.18,84,431.27,84.14Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,87.34c.09.11-5.48,4.9-12.43,10.71s-12.67,10.43-12.76,10.32,5.47-4.91,12.43-10.72S432.89,87.23,433,87.34Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.79,91.29c.1.11-4.78,4.33-10.88,9.43s-11.13,9.14-11.22,9,4.78-4.33,10.88-9.43S433.7,91.18,433.79,91.29Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,95.68c.09.11-3.82,3.53-8.74,7.64s-9,7.35-9.08,7.24,3.82-3.53,8.75-7.64S434,95.57,434.08,95.68Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.63,81.5c.1.11-5.65,5.06-12.82,11s-13.08,10.77-13.17,10.66,5.65-5.06,12.83-11.06S428.54,81.39,428.63,81.5Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,78.86c.09.11-5.66,5.06-12.83,11S400.1,100.68,400,100.57s5.65-5.06,12.83-11.06S425.9,78.75,426,78.86Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.33,77.08c.09.11-4.85,4.39-11.05,9.57S400,95.93,399.9,95.82s4.85-4.4,11.05-9.57S422.24,77,422.33,77.08Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.59,76.2c.09.11-3.8,3.51-8.68,7.59s-8.93,7.3-9,7.19,3.79-3.51,8.68-7.59S417.5,76.09,417.59,76.2Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.56,
    cy: 67.78,
    r: 3.2,
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,278.23a3.2,3.2,0,1,1-3.2-3.19A3.2,3.2,0,0,1,309.5,278.23Z",
    style: {
      fill: "#D41335"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.16,109a11.64,11.64,0,0,0-10.25-9.75,15.32,15.32,0,0,1-4-.44,23,23,0,0,1-2.85-1.63,7.77,7.77,0,0,0-9.49,2c-2,2.61-2.87-1-7.68,1.84-4,2.37-1.9,5.66-1.9,5.66a8.93,8.93,0,0,0-8.85,7.06c-.47,2.57,0,5.69-2,7.37-1,.81-2.32,1-3.33,1.81-1.86,1.44-1.92,4.22-1.5,6.53s1.14,4.76.28,7c-1.41,3.59-6.52,5-7.15,8.82-.3,1.8.45,4-.8,5.28a6.08,6.08,0,0,1-1.88,1.1,8.13,8.13,0,0,0-.3,14.45c.72.39,1.59.76,1.86,1.54s-.26,1.77-.67,2.59a7.82,7.82,0,0,0,11.12,10.14A12.21,12.21,0,0,0,116,186a7.4,7.4,0,0,0,4.27.11,8.28,8.28,0,0,0,2.94-1.8c4.16-3.63,10-9.17,10.38-14.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,129.08a4.9,4.9,0,0,1-1.93,0,11.34,11.34,0,0,1-7.65-5,4.7,4.7,0,0,1-.81-1.74,15.31,15.31,0,0,1,1.11,1.53,13.35,13.35,0,0,0,3.29,3,13.51,13.51,0,0,0,4.13,1.75A14.67,14.67,0,0,1,119.9,129.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.69,116.43a4.2,4.2,0,0,1-1.25,1.25,11.08,11.08,0,0,1-8.11,2.07,4.2,4.2,0,0,1-1.7-.5,18,18,0,0,0,5.83-.24A17.61,17.61,0,0,0,122.69,116.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.25,179s-.06,0-.17,0a4.63,4.63,0,0,1-.5-.15,6.11,6.11,0,0,1-1.72-1,6.63,6.63,0,0,1-2-2.43,6.5,6.5,0,0,1-.48-4.1,6.75,6.75,0,0,1,.89-2.26,8.81,8.81,0,0,1,1.76-2,9.26,9.26,0,0,0,1.82-2,2.7,2.7,0,0,0,.08-2.59,13.06,13.06,0,0,0-1.79-2.43,8.83,8.83,0,0,1-.93-1.34,5.1,5.1,0,0,1-.54-1.61,5.7,5.7,0,0,1,3.1-5.87,18.66,18.66,0,0,1,3.38-.79,3.87,3.87,0,0,0,1.44-.61,2.29,2.29,0,0,0,.83-1.2,4.77,4.77,0,0,0-.33-3c-.39-.95-.93-1.85-1.28-2.81a4.5,4.5,0,0,1-.21-3,4.85,4.85,0,0,1,1.71-2.29,13.19,13.19,0,0,1,4.62-1.94,10.31,10.31,0,0,0,3.64-1.66,4.58,4.58,0,0,0,1.52-2.53,2.85,2.85,0,0,0-.18-1.86c-.19-.4-.37-.56-.34-.58a1.54,1.54,0,0,1,.44.53,2.91,2.91,0,0,1,.28,1.94,4.66,4.66,0,0,1-1.53,2.72,10.21,10.21,0,0,1-3.73,1.79,13,13,0,0,0-4.45,1.93,4.31,4.31,0,0,0-1.54,2.09,4,4,0,0,0,.22,2.71c.34.92.87,1.79,1.29,2.79a5.27,5.27,0,0,1,.36,3.3,2.84,2.84,0,0,1-1,1.47,4.38,4.38,0,0,1-1.63.71,18.49,18.49,0,0,0-3.28.75,5.19,5.19,0,0,0-2.81,5.32,4.74,4.74,0,0,0,.47,1.45,8.46,8.46,0,0,0,.88,1.27,12.82,12.82,0,0,1,1.83,2.54,3.17,3.17,0,0,1-.12,3,9.13,9.13,0,0,1-1.92,2.07,8.45,8.45,0,0,0-1.71,1.85,6.39,6.39,0,0,0-.87,2.13,6.21,6.21,0,0,0,.38,3.9,6.59,6.59,0,0,0,1.83,2.39A8.32,8.32,0,0,0,102.25,179Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.32,
    y: 429.3,
    width: 107.71,
    height: 5.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,435s0-.13,0-.36,0-.6,0-1.06c0-1,0-2.38-.05-4.3l.08.08c-14,.1-56.95.18-107.71.18h0l.26-.26V435l-.26-.26,76.28.11,23,.08,6.25,0,1.63,0,.57,0-.53,0-1.6,0-6.19,0-22.92.08-76.47.11h-.26V429h.26c50.76,0,93.74.07,107.71.18h.08v.08c0,1.94,0,3.37-.05,4.34,0,.46,0,.8,0,1.05A2.06,2.06,0,0,1,206,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.6 330.16 86.86 483.78 94.44 483.78 115.02 332.16 115.02 330.16 109.6 330.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6,330.16s.41,0,1.3,0l4.12,0h.07v.07c0,.6,0,1.27,0,2h0c-2.46,18.91-10.62,79.63-20.4,151.64l0,.23H86.56l0-.3C93,441,98.7,402.55,102.83,374.8c2.08-13.84,3.76-25,4.93-32.73.58-3.84,1-6.82,1.35-8.86l.35-2.29c.09-.51.14-.76.14-.76s0,.27-.1.8-.18,1.32-.33,2.33c-.29,2-.72,5-1.28,8.92-1.12,7.74-2.75,18.94-4.77,32.81-4.08,27.71-9.72,66.08-16,108.8l-.26-.3h7.59l-.26.22C104,411.73,112.28,351,115,332.15h0c0-.73,0-1.4,0-2l.06.06-4.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.72 330.16 217.94 483.78 210.35 483.78 189.3 332.16 189.3 330.16 194.72 330.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,330.16l-1.34,0-4.08,0,.06-.06c0,.6,0,1.27,0,2h0c2.73,18.88,11.24,79.57,21.24,151.59l-.25-.22h7.58l-.26.3c-6.41-42.71-12.18-81.09-16.34-108.8-2.06-13.87-3.72-25.06-4.88-32.81-.56-3.87-1-6.87-1.31-8.92-.14-1-.25-1.79-.33-2.33s-.1-.8-.1-.8.05.25.14.76.2,1.3.36,2.29c.32,2,.78,5,1.38,8.86,1.19,7.72,2.9,18.89,5,32.73,4.22,27.75,10.06,66.17,16.57,108.94l0,.3h-8.11l0-.23c-10-72-18.36-132.73-20.88-151.64h0c0-.73,0-1.4,0-2v-.07h.07l4.11,0C194.31,330.14,194.72,330.16,194.72,330.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.46,
    y: 330.16,
    width: 6.48,
    height: 153.62,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,483.78s0-.28,0-.81,0-1.31,0-2.32c0-2,0-5.06,0-8.92,0-7.75-.05-18.94-.08-32.8,0-27.71-.07-66.08-.11-108.77l.26.26h-6.48l.26-.26c0,73.55-.08,135.5-.19,153.62l-.07-.07,4.89,0h1.19l.4,0h-.37l-1.18,0-4.93,0h-.07v-.07c-.11-18.12-.19-80.07-.19-153.62v-.26h7v.26c0,42.77-.08,81.2-.1,109,0,13.84-.07,25-.08,32.74,0,3.84,0,6.82,0,8.86,0,1,0,1.76,0,2.29S152.94,483.78,152.94,483.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.1,
    y: 319.89,
    width: 88.91,
    height: 11.55,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.25,320.22A27,27,0,0,1,131,323a35.36,35.36,0,0,1-3.9,2.45,34.93,34.93,0,0,1-10.61,3.66,33.87,33.87,0,0,1-4.58.47,27.19,27.19,0,0,1-4.23-.15H108l.85,0c.72,0,1.78,0,3.08,0a35.69,35.69,0,0,0,4.55-.51,40,40,0,0,0,5.43-1.41,40.94,40.94,0,0,0,5.13-2.23,36.65,36.65,0,0,0,3.9-2.4c1.06-.76,1.9-1.41,2.45-1.89l.64-.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,327.81l-.22-.08c-.14-.06-.35-.17-.63-.28a12,12,0,0,0-2.56-.66,11.85,11.85,0,0,0-4.14.15,11.28,11.28,0,0,0-4.86,2.36l0-.14a37.86,37.86,0,0,0,9.83,1.07,37.05,37.05,0,0,0,5.63-.57,8.46,8.46,0,0,0,2.8-.82,2.07,2.07,0,0,0,.91-1.09,2.2,2.2,0,0,0-.05-1.43,3.56,3.56,0,0,0-2.59-2.1,19.84,19.84,0,0,0-3.41-.47,36.06,36.06,0,0,0-6.52.13,37.5,37.5,0,0,0-17.2,6.4c-.73.49-1.27.92-1.64,1.2l-.57.42s.18-.16.55-.45.88-.73,1.61-1.23a35.24,35.24,0,0,1,6.52-3.67,36.86,36.86,0,0,1,10.7-2.86,37.5,37.5,0,0,1,6.57-.15,20.88,20.88,0,0,1,3.45.48,5.15,5.15,0,0,1,1.63.76,3.2,3.2,0,0,1,1.09,1.47,2.29,2.29,0,0,1,0,1.57,2.16,2.16,0,0,1-1,1.19,8.6,8.6,0,0,1-2.87.85,36.39,36.39,0,0,1-5.67.56,37.21,37.21,0,0,1-9.87-1.1l-.15,0,.12-.1a11.38,11.38,0,0,1,5-2.37,11.67,11.67,0,0,1,4.17-.11,10.94,10.94,0,0,1,2.57.71C146.69,327.66,147,327.81,147,327.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.49,320.19a2.09,2.09,0,0,1,.6.16,4.26,4.26,0,0,1,1.4,1,4.9,4.9,0,0,1,1.19,2.22,5.5,5.5,0,0,1-.25,3.08,7.4,7.4,0,0,1-3.84,3.95,9.83,9.83,0,0,1-1.59.58l-.45.11c-.11,0-.16,0-.16,0a3.77,3.77,0,0,1,.58-.21,10.3,10.3,0,0,0,1.55-.64,7.33,7.33,0,0,0,3.71-3.89,5.24,5.24,0,0,0,.26-3,4.79,4.79,0,0,0-1.11-2.17A4.72,4.72,0,0,0,158.49,320.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.41,320.14a14.44,14.44,0,0,0-1.95,1,13.27,13.27,0,0,0-3.73,3.66,29.1,29.1,0,0,0-2.52,4.63l-.66,1.46c-.16.34-.25.53-.26.53a2.33,2.33,0,0,1,.18-.56c.14-.36.34-.87.6-1.49a25.4,25.4,0,0,1,2.49-4.69,12.72,12.72,0,0,1,3.82-3.67,8.49,8.49,0,0,1,1.46-.69,4.33,4.33,0,0,1,.42-.13C172.35,320.14,172.41,320.13,172.41,320.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,327l-.52-.23a8.94,8.94,0,0,0-1.53-.49,8.74,8.74,0,0,0-5.75.64,1.61,1.61,0,0,0-.72.56.67.67,0,0,0,.09.83,5.25,5.25,0,0,0,1.87.9,18.5,18.5,0,0,0,4.58,1,19.19,19.19,0,0,0,5.15-.25,5.23,5.23,0,0,0,2.46-1,2.16,2.16,0,0,0,.56-2.47,3.6,3.6,0,0,0-1.89-1.91,12.3,12.3,0,0,0-2.59-.86,18.2,18.2,0,0,0-5.14-.42,17.77,17.77,0,0,0-8.28,2.63,18.52,18.52,0,0,0-4.45,3.86c-.45.55-.77,1-1,1.29l-.33.46a14.1,14.1,0,0,1,1.24-1.8A18.66,18.66,0,0,1,176,325.7a17.85,17.85,0,0,1,8.35-2.69,18.26,18.26,0,0,1,5.2.41,12.29,12.29,0,0,1,2.63.87,3.87,3.87,0,0,1,2,2,2.61,2.61,0,0,1,.13,1.46,2.38,2.38,0,0,1-.75,1.24,5.37,5.37,0,0,1-2.56,1.08,19.24,19.24,0,0,1-5.21.25,19.78,19.78,0,0,1-4.62-1c-.35-.12-.69-.26-1-.39a2.44,2.44,0,0,1-.91-.58.83.83,0,0,1-.1-1,1.9,1.9,0,0,1,.78-.61,8.8,8.8,0,0,1,5.84-.58A7,7,0,0,1,187.77,327Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,173a15.08,15.08,0,0,0-7.75,6.73c-2.91,5.15-2.13,7.69-1.37,10.74s2.1,9.08,2.17,8.69S130.13,173,130.13,173Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 173.03 136.57 169.4 165.02 158.75 159.43 206.57 138.43 219.79 125.99 213.57 124.75 199.73 130.45 173.03",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.71 245.8 118.59 260.22 104.81 256.98 93.79 263.14 96.71 268.33 125.95 270.29 136.26 249.04 129.71 245.8",
    style: {
      fill: "#7c3b29"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.97 384.22 107.19 408.54 125.29 400.17 113.69 370.08 95.97 384.22",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,406.91l6.55,12.5s-16.78,17.35-15.2,21.23l39.44-18.91L125,396.66Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,411.85a1.79,1.79,0,0,1,2,1.31,1.72,1.72,0,0,1-1.27,2,1.89,1.89,0,0,1-2.11-1.39,1.79,1.79,0,0,1,1.56-1.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.86,421.73l-1.64-3.15L97,437.89s-1.39,1.6-.6,2.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,419.52c.09.19,1.1-.19,2.34,0s2.14.73,2.28.57-.68-1.14-2.19-1.31S110.76,419.36,110.89,419.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57,423.21c0,.21,1,.14,2.08.64s1.65,1.27,1.83,1.17-.21-1.25-1.52-1.85S107.48,423,107.57,423.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,429.29c.2,0,0-1.14-1-2s-2.1-.81-2.1-.61.82.5,1.63,1.18S107.39,429.36,107.59,429.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,414.7c.17.14.92-.55,2-1s2.14-.51,2.16-.72-1.13-.51-2.44,0S108.84,414.6,109,414.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,412.2s-.2-.25-.37-.79a5.78,5.78,0,0,1-.18-2.38,2.84,2.84,0,0,1,.18-.8,1,1,0,0,1,.79-.64.71.71,0,0,1,.59.2,1,1,0,0,1,.24.54,6.54,6.54,0,0,1,0,1c0,.67,0,1.31-.16,2.08a1.25,1.25,0,0,1-.82,1,2.46,2.46,0,0,1-1.23.05,9.9,9.9,0,0,1-3.13-1.11,2.86,2.86,0,0,1-.88-.67.93.93,0,0,1,0-1.17,1.11,1.11,0,0,1,1-.25,6.76,6.76,0,0,1,1.55.63,8.45,8.45,0,0,1,1.91,1.42c.39.4.57.65.54.68a15.82,15.82,0,0,0-2.62-1.77,6.58,6.58,0,0,0-1.45-.54.73.73,0,0,0-.64.13.48.48,0,0,0,.06.58,2.55,2.55,0,0,0,.74.52,8.67,8.67,0,0,0,.92.44,9.72,9.72,0,0,0,2,.6,2,2,0,0,0,1,0,.72.72,0,0,0,.49-.6c.09-.64.12-1.38.18-2a5.94,5.94,0,0,0,0-.91c0-.26-.14-.38-.33-.37-.43,0-.58.61-.65,1.07A8.2,8.2,0,0,0,107.85,412.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,392.57,67.14,321.46s.66-12.62,3-16.61S142.9,277.6,142.9,277.6s17.94-4.31,29.9,0,20.93,19.28,19.27,27.58-8.67,14.41-8.67,14.41l-51.8,1.54-28.23,10.3,19,54.5S112.66,396.56,95.71,392.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.41 344.9 69.74 371.67 89.68 372.15 92.55 340.03 70.41 344.9",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.55,369.27l.37,14.11s-22.71,8.16-23,12.34l43.73.44L91,368.88Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,381.62a1.8,1.8,0,0,1,1.22,2.06,1.73,1.73,0,0,1-2,1.22,1.89,1.89,0,0,1-1.27-2.18,1.78,1.78,0,0,1,2.24-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.64,396.16l-.08-3.55-41.9.91s-2,.82-1.75,2.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.21,383.15c0,.22,1.07.32,2.12,1s1.59,1.6,1.79,1.52-.11-1.32-1.39-2.14S68.17,383,68.21,383.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.61,385c-.06.21.87.58,1.58,1.49s.92,1.87,1.13,1.86.36-1.21-.55-2.32S63.61,384.8,63.61,385Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,390.47c.2,0,.51-1,0-2.19s-1.53-1.65-1.62-1.48.52.81.94,1.78S60.73,390.44,60.94,390.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.65,378c.09.2,1.07-.09,2.28,0s2.14.48,2.25.3-.78-.95-2.2-1S68.55,377.83,68.65,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.71,375.25a2,2,0,0,1,0-.87,5.83,5.83,0,0,1,.88-2.22,3.25,3.25,0,0,1,.52-.64,1,1,0,0,1,1-.22.71.71,0,0,1,.44.44,1,1,0,0,1,0,.59,7.38,7.38,0,0,1-.46.89c-.34.57-.63,1.15-1.06,1.79a1.24,1.24,0,0,1-1.17.53,2.38,2.38,0,0,1-1.13-.5,10.23,10.23,0,0,1-1.67-1.53c-.23-.28-.45-.56-.65-.85a2.74,2.74,0,0,1-.49-1,.92.92,0,0,1,.5-1.07,1.1,1.1,0,0,1,1,.24,6.6,6.6,0,0,1,1.11,1.26,8.34,8.34,0,0,1,1.09,2.11,2.42,2.42,0,0,1,.19.85,16.21,16.21,0,0,0-1.58-2.74,6.62,6.62,0,0,0-1.06-1.13.74.74,0,0,0-.63-.17.47.47,0,0,0-.2.55,2.39,2.39,0,0,0,.43.79,9.31,9.31,0,0,0,.63.81A9.91,9.91,0,0,0,68,374.62a2.22,2.22,0,0,0,.89.41.75.75,0,0,0,.71-.33c.36-.53.71-1.18,1-1.72a6,6,0,0,0,.44-.8c.09-.25,0-.41-.13-.48-.4-.16-.79.29-1.06.67A8.35,8.35,0,0,0,68.71,375.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05,270.58s-12-.95-13.27,12S66.14,356,66.14,356l27.91,2.33,4.32-61.81L142.9,277.6S90,268.92,82.05,270.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.28,253.1s-7.25,20.32-5.87,22.59,20,11.58,20,11.58l46.64,17.91a39.08,39.08,0,0,0,4.79-19.32c0-11.71-16.22-32.76-16.22-32.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,276.57s-.07,0-.22.12l-.66.3-2.58,1.15-9.7,4.23-33.47,14.4.15-.21c-.42,6.11-.88,12.7-1.35,19.52-1.14,15.95-2.18,30.65-3,42.28l0,.21-.2,0L73.7,356.77l-5.6-.52-1.46-.16a2.5,2.5,0,0,1-.5-.07,2.79,2.79,0,0,1,.51,0l1.46.09,5.61.41,20.35,1.61-.22.19c.79-11.63,1.8-26.34,2.9-42.29.48-6.82.94-13.41,1.37-19.51v-.16l.14-.06,33.55-14.23,9.75-4.09,2.62-1.08.68-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2,278.6a5.67,5.67,0,0,1-1.31-.36l-3.51-1.13a77,77,0,0,0-11.76-3,34.32,34.32,0,0,0-12,.16,47.42,47.42,0,0,0-4.82,1.39,6.73,6.73,0,0,1,1.21-.61,21.28,21.28,0,0,1,3.53-1.14,32.1,32.1,0,0,1,12.19-.31,65.43,65.43,0,0,1,11.79,3.13c1.47.52,2.65,1,3.47,1.29A7,7,0,0,1,182.2,278.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,267.89a32.93,32.93,0,0,0-4.07,0c-1.26.08-2.75.28-4.42.47s-3.48.42-5.37.78a24.81,24.81,0,0,0-9.14,3.39,27.84,27.84,0,0,0-3.17,2.55,3.48,3.48,0,0,1,.68-.88,13.89,13.89,0,0,1,2.28-2,23.45,23.45,0,0,1,9.25-3.59c1.91-.37,3.75-.58,5.42-.75s3.17-.32,4.45-.36a16.28,16.28,0,0,1,3,.13A3.47,3.47,0,0,1,175.6,267.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.13,173s-7.93,25.43-7.75,32.71,3.2,28,2.85,32,1.08,15.32,6,15.32h49.36s11.15-3.09,11.63-9.78-15-71.66-15-71.66-2.92-11.94-7-12.81-8.64,0-11.37,8.43-3.64,20.33-9.47,26.16-14.12,12.37-14.12,12.37-6.69-5.6-7-13.18,2.54-19.85,2.54-19.85Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.09,177.46a10.61,10.61,0,0,0-5.43-4.17,25.82,25.82,0,0,0-6.82-1.31,18.23,18.23,0,0,0-6.21.22c-2,.52-2.84,3-3.68,4.92a62.09,62.09,0,0,0,1.33,25.63,8.11,8.11,0,0,0,4.33,6,12.73,12.73,0,0,0,5.71,2.32c3.7.28,7.11-2.4,8.84-5.68s2.12-7.08,2.47-10.77q.35-3.47.67-6.93C183.64,184.19,183.92,180.43,182.09,177.46Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.44,253.65a4.68,4.68,0,0,1-1.95-1,11.68,11.68,0,0,1-3.3-4.18,22.21,22.21,0,0,1-1.68-5,8.28,8.28,0,0,1-.34-2.17,10.23,10.23,0,0,1,.69,2.08,30.46,30.46,0,0,0,1.8,4.9,13.06,13.06,0,0,0,3.06,4.13C136.72,253.21,137.48,253.57,137.44,253.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56,222.13a4.43,4.43,0,0,1-.83.7,16.29,16.29,0,0,1-2.55,1.49,15.61,15.61,0,0,1-4.22,1.26,14.54,14.54,0,0,1-5.38-.23,17.72,17.72,0,0,1-8.38-4.87,21.58,21.58,0,0,1-1.93-2.23,4.94,4.94,0,0,1-.58-.92c.08-.06,1,1.2,2.76,2.89a18.47,18.47,0,0,0,8.25,4.62A15.15,15.15,0,0,0,160,224C162.29,223,163.5,222,163.56,222.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.83,252.73c-.11.09-.79-.69-1-1.9a2.72,2.72,0,0,1,.22-2.15c.15,0,.07.95.29,2S137,252.65,136.83,252.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,177.34a2.67,2.67,0,0,0-1.21.61,2.8,2.8,0,0,0-.77,1.39,2.18,2.18,0,0,0,.45,2l.18.18-.25.08a4.65,4.65,0,0,0-2.79,2.5,4.78,4.78,0,0,0,.1,4.51l.3.49-.56-.15a3.3,3.3,0,0,0-3.58,5l-.46.23a1.83,1.83,0,0,0-2.28-.88,2.81,2.81,0,0,0-1.95,2,10.59,10.59,0,0,0-.42,3L144,199.7l-.43-1.38a1.68,1.68,0,0,0-1.86-1,2.36,2.36,0,0,0-1.67,1.4c-.66,1.41-.26,3,0,4.29l-.4,0a2.22,2.22,0,0,0-.85-1.72,2.6,2.6,0,0,0-1.66-.62,2.17,2.17,0,0,0-2,1.81,2.63,2.63,0,0,0,.24,1.86c.22.38.42.53.4.56a1.41,1.41,0,0,1-.5-.5,2.84,2.84,0,0,1,.27-3.3,2.22,2.22,0,0,1,1.6-.76,2.94,2.94,0,0,1,1.91.66,2.67,2.67,0,0,1,1,2v1.65l-.39-1.6a13.91,13.91,0,0,1-.42-2.17,4.53,4.53,0,0,1,.35-2.41,2.8,2.8,0,0,1,2-1.69,2.16,2.16,0,0,1,2.42,1.31l-.49.07a11,11,0,0,1,.44-3.11,4.29,4.29,0,0,1,.81-1.46,3,3,0,0,1,1.5-.9,3,3,0,0,1,1.69,0,1.93,1.93,0,0,1,1.21,1.17l.72,2-1.18-1.81a3.78,3.78,0,0,1,4.13-5.74l-.26.35a5.17,5.17,0,0,1-.06-4.92,4.92,4.92,0,0,1,3.06-2.64l-.07.26a2.41,2.41,0,0,1-.46-2.25,2.87,2.87,0,0,1,.9-1.45,2.27,2.27,0,0,1,.95-.48A1.47,1.47,0,0,1,157.28,177.34Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.37,173.18s.06,0,.14.19a1.71,1.71,0,0,1,.18.67,2.2,2.2,0,0,1-.23,1.1,2,2,0,0,1-1.15,1l0-.23a3.89,3.89,0,0,1,1.41,3,4.15,4.15,0,0,1-2,3.72l0-.37a4.08,4.08,0,0,1,1.38,4.19,11,11,0,0,1-2.44,4.33l-.41-.32a1.91,1.91,0,0,1,3,.23,3,3,0,0,1,.1,2.89,7,7,0,0,1-1.72,2.13l-.26-.43a2.84,2.84,0,1,1,1.76,5.39l-.57.16.34-.49a2.11,2.11,0,0,1,2.05-.77,3.13,3.13,0,0,1,1.76.84,4,4,0,0,1,1.07,2.87,10,10,0,0,1-.16,1.94,2.79,2.79,0,0,1-.15.66c-.08,0,.13-.94.07-2.59a3.84,3.84,0,0,0-1.06-2.63A2.93,2.93,0,0,0,132,200a1.73,1.73,0,0,0-1.65.65l-.23-.33a2.51,2.51,0,0,0,1.63-2.83,2.45,2.45,0,0,0-3.1-1.67l-1.16.41.9-.84a6.55,6.55,0,0,0,1.59-2,2.43,2.43,0,0,0-.06-2.37,1.41,1.41,0,0,0-2.16-.22l-.41-.31a10.67,10.67,0,0,0,2.37-4.11,3.62,3.62,0,0,0-1.15-3.73l-.29-.2.31-.18a3.75,3.75,0,0,0,1.83-3.32,3.65,3.65,0,0,0-1.21-2.81L129,176l.25-.07a1.77,1.77,0,0,0,1-.85,2.09,2.09,0,0,0,.27-1A2.44,2.44,0,0,0,130.37,173.18Z",
    style: {
      fill: "#D41335"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.52,218.47a14.4,14.4,0,0,0,5.07,9.7,11.93,11.93,0,0,0,10.56,2.3,10.25,10.25,0,0,0,7.22-7.84,29.87,29.87,0,0,1-7.88,2.74,15.46,15.46,0,0,1-15.21-7.18c.13.15.27.29.4.43"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.15,242a11.06,11.06,0,0,0,3.52,10.3,2.35,2.35,0,0,0,2.21.75,26.38,26.38,0,0,1-5.67-11.28"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M168.84,169.07s-11.17,1.75-8.47,17.63,22,42.77,22,42.77L140.18,255.2l4.92,11.43,54.79-22.55s5.4-5.56,3.5-11.75-16-45.18-16-45.18S182.18,166.37,168.84,169.07Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37,265l15.1-9.54,20,.94,1.68-1.16,4.92,11.43s-5.39,2.58-8.21,2.81l-17.47-1.33-18.56-1.39Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32,229.78a9.32,9.32,0,0,1-1-1.29c-.6-.85-1.45-2.1-2.48-3.65-2.05-3.12-4.78-7.49-7.59-12.44s-5.15-9.54-6.77-12.9c-.81-1.68-1.44-3.05-1.86-4A8.43,8.43,0,0,1,162,194a10.09,10.09,0,0,1,.78,1.42l2,3.93c1.7,3.31,4.1,7.86,6.9,12.8s5.47,9.34,7.44,12.5l2.34,3.74A9.43,9.43,0,0,1,182.32,229.78Z",
    style: {
      fill: "#7c3b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.7,233.4a36.41,36.41,0,0,0-5-2.63,36.2,36.2,0,0,0-5.55-1.3,13.67,13.67,0,0,1,10.6,3.93Z",
    style: {
      fill: "#7c3b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.55,217.33c.38,1.16,15.54,52.11,15.54,52.11l87,6.25,3.2-5.4-48.58-3.66L86.08,214.35a4.38,4.38,0,0,0-4.92-3.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,238.71c.73,1.52.43,3.18-.69,3.72s-2.61-.25-3.34-1.76-.43-3.18.68-3.72S69.27,237.2,70,238.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,273.13h-.26l-.73,0-2.85-.16-10.54-.7-35.3-2.54-.18,0-.05-.17c-.47-1.64-1-3.38-1.48-5.14L84.56,226.86l-3.17-11.38c-.36-1.32-.64-2.36-.84-3.11-.08-.33-.15-.59-.2-.81a.93.93,0,0,1-.06-.28,1,1,0,0,1,.11.27c.06.21.15.47.25.8.23.74.54,1.76.93,3.07l3.34,11.34,10.82,37.47c.5,1.76,1,3.5,1.47,5.14l-.23-.19,35.29,2.71,10.52.86,2.84.25.74.08A.79.79,0,0,1,146.62,273.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,117.44l-.08-3.92L135.11,110c-7.28-.47-14.81,7.1-15,14.39-.18,8.1-.08,18,1.12,24,2.42,12,11.77,13.21,11.77,13.21l.54,12,26.81-.75Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,132.88a1.54,1.54,0,0,0,1.56,1.5,1.49,1.49,0,0,0,1.55-1.46,1.56,1.56,0,0,0-1.56-1.51A1.49,1.49,0,0,0,125.15,132.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,129.45c.2.19,1.35-.73,3-.79s2.93.72,3.1.51-.12-.45-.67-.82a4.3,4.3,0,0,0-2.5-.66,4.14,4.14,0,0,0-2.39.88C123,129,122.81,129.36,122.9,129.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.78,132.54a1.57,1.57,0,0,0,1.56,1.51,1.5,1.5,0,0,0,1.55-1.47,1.55,1.55,0,0,0-1.56-1.51A1.5,1.5,0,0,0,140.78,132.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,129.09c.2.2,1.34-.72,3-.78s2.93.72,3.11.51-.13-.46-.68-.82a4.19,4.19,0,0,0-2.49-.66,4,4,0,0,0-2.39.88C139.42,128.63,139.26,129,139.36,129.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.79,141.74a11.62,11.62,0,0,0-2.74-.38c-.43,0-.83-.09-.92-.38a2.2,2.2,0,0,1,.24-1.28c.36-1,.73-2.15,1.13-3.3,1.56-4.7,2.68-8.56,2.49-8.62s-1.61,3.7-3.18,8.4c-.38,1.16-.74,2.26-1.08,3.32a2.49,2.49,0,0,0-.15,1.68,1.06,1.06,0,0,0,.73.6,2.76,2.76,0,0,0,.73.07A10.63,10.63,0,0,0,133.79,141.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,161.62a32.16,32.16,0,0,0,16.47-5s-3.75,8.65-16.34,8Z",
    style: {
      fill: "#7c3b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.66,145.74a3,3,0,0,1,2.66-1.23,2.75,2.75,0,0,1,1.94,1,1.75,1.75,0,0,1,.21,2,2,2,0,0,1-2.17.64,6.42,6.42,0,0,1-2.19-1.19,2.07,2.07,0,0,1-.5-.48.56.56,0,0,1,0-.62",
    style: {
      fill: "#7c3b29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,142.7c-.27,0-.2,1.81-1.71,3.16s-3.44,1.23-3.44,1.49.44.33,1.26.32a4.55,4.55,0,0,0,2.88-1.14,3.91,3.91,0,0,0,1.31-2.64C139.1,143.13,138.88,142.68,138.76,142.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.66,122.56c.18.44,1.84.16,3.81.32s3.58.63,3.83.21c.11-.2-.19-.62-.84-1a6.63,6.63,0,0,0-5.82-.41C138.93,122,138.58,122.34,138.66,122.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,124.58c.31.37,1.45-.07,2.83-.15s2.57.16,2.83-.25c.11-.2-.09-.57-.62-.91a3.9,3.9,0,0,0-2.33-.53,4,4,0,0,0-2.23.85C123.33,124,123.18,124.4,123.32,124.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,109.72c2,4.24,6.32,10.55,11,11a13.71,13.71,0,0,0,12.19-5.5c.78,3.44,4.66,5.19,8.15,5.68a13.79,13.79,0,0,0,7.35-.67,7.34,7.34,0,0,0,4.55-5.51c.32-2.47-3.33-8.44-5.79-8.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.83,171.66a9.58,9.58,0,0,0,7,8.48,6.77,6.77,0,0,0,13.1,2.63,7.9,7.9,0,0,1,1-2.29c1.18-1.51,3.5-1.21,5.32-1.8,3.28-1.06,4.7-5.08,4.33-8.51a8.22,8.22,0,0,1-.09-2c.2-1.37,1.28-2.42,2.08-3.56,3.3-4.68,1.92-11.47-1.74-15.88-1.22-1.47-2.76-3-2.64-4.91a10.08,10.08,0,0,1,1-3,8.67,8.67,0,0,0-2.33-9.45,2.69,2.69,0,0,1-1-1.2,2.59,2.59,0,0,1,0-1,10.13,10.13,0,0,0-8.56-10.81,2.46,2.46,0,0,1-.89-.2c-.78-.41-.81-1.48-.91-2.35-.27-2.31-2-6.61-3.81-8.12-4.9-4.18-9.64-.78-11.33.81,0,0-3.35,16.6-2.7,19.7s2.92,10.8,2,14.3-2.37,10.67-1,13.83S154.83,171.66,154.83,171.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.13,118.25s-.21.22-.64.53a16.92,16.92,0,0,1-1.94,1.16A23.77,23.77,0,0,1,156,122.33a14.79,14.79,0,0,1-2.22-.49,3,3,0,0,1-.78-.28c0-.09,1.17.2,3,.41a27.64,27.64,0,0,0,7.33-.19,26.88,26.88,0,0,0,7-2.17C172.09,118.82,173.08,118.18,173.13,118.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.73,119.43a4.68,4.68,0,0,1-.36,1,8.22,8.22,0,0,1-.53,1.11,13.69,13.69,0,0,1-.81,1.41,21.78,21.78,0,0,1-2.62,3.35,24.65,24.65,0,0,1-4,3.34,25.09,25.09,0,0,1-4.64,2.36,21.52,21.52,0,0,1-4.11,1.08,13.45,13.45,0,0,1-1.62.2,9.05,9.05,0,0,1-1.23,0,3.62,3.62,0,0,1-1.05-.06c0-.1,1.5-.08,3.83-.54a23.93,23.93,0,0,0,4-1.17,24.54,24.54,0,0,0,8.47-5.58,23.78,23.78,0,0,0,2.65-3.22C174.07,120.77,174.63,119.39,174.73,119.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.05,181.1s.21,0,.58-.06a2.62,2.62,0,0,0,1.39-.84,3.52,3.52,0,0,0,.91-2.38,11.39,11.39,0,0,0-.63-3.44A7.48,7.48,0,0,1,168,170c.52-1.58,1.78-2.79,2.91-4.09a8.16,8.16,0,0,0,1.45-2.14,3.06,3.06,0,0,0-.08-2.51,5.74,5.74,0,0,0-1.88-2c-.78-.57-1.64-1.07-2.47-1.68a5.42,5.42,0,0,1-2-2.37,3.72,3.72,0,0,1,.31-3c.94-1.73,2.41-3,2.75-4.63a5.56,5.56,0,0,0-1.23-4.45,19.56,19.56,0,0,0-2.92-3.12,19.91,19.91,0,0,1-2.44-2.63,8,8,0,0,1-1.27-2.41,5.11,5.11,0,0,1-.2-1.71,2.45,2.45,0,0,1,.11-.58,6.79,6.79,0,0,0,.28,2.23,12.4,12.4,0,0,0,3.77,4.83,19.26,19.26,0,0,1,3,3.13,8.12,8.12,0,0,1,1.17,2.18,4.67,4.67,0,0,1,.18,2.63c-.39,1.86-1.92,3.16-2.76,4.77a3.14,3.14,0,0,0-.28,2.59,4.89,4.89,0,0,0,1.81,2.12c.79.59,1.66,1.09,2.46,1.68a6.21,6.21,0,0,1,2,2.19,3.52,3.52,0,0,1,.08,2.91,8.26,8.26,0,0,1-1.55,2.28c-1.16,1.31-2.38,2.48-2.86,3.9a7.21,7.21,0,0,0,.21,4.13,11.52,11.52,0,0,1,.56,3.56,3.72,3.72,0,0,1-1.05,2.5,2.59,2.59,0,0,1-1.52.8A1.39,1.39,0,0,1,166.05,181.1Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.5ec423d84eefaaddbace35bc1c3bf636.svg";
export { ForwardRef as ReactComponent };